import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ScrollResetService } from './services/scroll.service';
import { NavigationService } from './services/navigation.service';
import { validacionRolService } from './services/validacion-rol.service';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { AreasComponent } from './pages/catalog/areas/areas.component';
import { ClientesComponent } from './pages/catalog/clientes/clientes.component';
import { ProyectosComponent } from './pages/catalog/proyectos/proyectos.component';
import { RolesComponent } from './pages/catalog/roles/roles.component';
import { UsuariosComponent } from './pages/catalog/usuarios/usuarios.component';
import { AreasDComponent } from './pages/catalog/areas/areas-d/areas-d.component';
import { ClientesDComponent } from './pages/catalog/clientes/clientes-d/clientes-d.component';
import { ProyectosDComponent } from './pages/catalog/proyectos/proyectos-d/proyectos-d.component';
import { RolesDComponent } from './pages/catalog/roles/roles-d/roles-d.component';
import { UsuariosDComponent } from './pages/catalog/usuarios/usuarios-d/usuarios-d.component';
import { FacturasComponent } from './pages/facturas/facturas.component';
import { FacturasDComponent } from './pages/facturas/facturas-d/facturas-d.component';
import { MenssagesComponent } from './components/menssages/menssages.component';
import { DeductivaComponent } from './pages/deductiva/deductiva.component';
import { DeductivaDComponent } from './pages/deductiva/deductiva-d/deductiva-d.component';
import { PenalizacionComponent } from './pages/penalizacion/penalizacion.component';
import { PenalizacionDComponent } from './pages/penalizacion/penalizacion-d/penalizacion-d.component';
import { ReportesComponent } from './pages/reportes/reportes.component';
import { ReportesDComponent } from './pages/reportes/reportes-d/reportes-d.component';
import { RefacturacionComponent } from './pages/refacturacion/refacturacion.component';
import { RefacturacionDComponent } from './pages/refacturacion/refacturacion-d/refacturacion-d.component';

import { NgxFileDropModule } from 'ngx-file-drop';
import { LoadingComponent } from './components/loading/loading/loading.component';
import { PdfViewerModule, PdfViewerComponent } from 'ng2-pdf-viewer';
import { ViewpdfComponent } from './components/viewpdf/viewpdf.component';


import { MsalGuard, MsalModule, MsalService, MSAL_INSTANCE, MsalInterceptor } from '@azure/msal-angular';
import { BrowserCacheLocation, PublicClientApplication, IPublicClientApplication, InteractionType } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { ErrorComponent } from './pages/error/error.component';
import { ReportesDsiComponent } from './pages/reportes/reportes-dsi/reportes-dsi.component';
import { EmailValidatorPipe } from './pipes/emailValidator/email-validator.pipe';
import { AniosComponent } from './pages/catalog/anios/anios.component';
import { AniosDComponent } from './pages/catalog/anios/anios-d/anios-d.component';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.azure.clientId,
      authority: environment.azure.authority,
      redirectUri: environment.azure.redirectUri,
      postLogoutRedirectUri: '/login'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
      allowNativeBroker: false, // Disables WAM Broker
      loggerOptions: {
        piiLoggingEnabled: false
      }
    },

  })
}



@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    HomeComponent,
    LoginComponent,
    AreasComponent,
    ClientesComponent,
    ProyectosComponent,
    RolesComponent,
    UsuariosComponent,
    AreasDComponent,
    ClientesDComponent,
    ProyectosDComponent,
    RolesDComponent,
    UsuariosDComponent,
    FacturasComponent,
    FacturasDComponent,
    MenssagesComponent,
    DeductivaComponent,
    DeductivaDComponent,
    PenalizacionComponent,
    PenalizacionDComponent,
    ReportesComponent,
    ReportesDComponent,
    RefacturacionComponent,
    RefacturacionDComponent,
    LoadingComponent,
    ViewpdfComponent,
    ReportesComponent,
    ErrorComponent,
    ReportesDsiComponent,
    EmailValidatorPipe,
    AniosComponent,
    AniosDComponent
  ],
  imports: [
    BrowserModule,
    MsalModule.forRoot( // config msal
      new PublicClientApplication({
        auth: {
          clientId: environment.azure.clientId,
          authority: environment.azure.authority,
          redirectUri: environment.azure.redirectUri,
        },
        cache: {
          cacheLocation: 'localStorage',
          storeAuthStateInCookie: true, // set to true for IE 11
        },
      }),
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: ['user.read', 'openid', 'profile', ],
        },
        loginFailedRoute: '/login',
      },  
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([
          ['https://graph.microsoft.com/v1.0/me', ['user.Read']],
          ['localhost', ['api://apiUri/api.scope']],
        ]),
      }
    ),

    AppRoutingModule,

    FormsModule,
    HttpClientModule,
    NgxFileDropModule,
    PdfViewerModule,

  ],
  providers: [
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    ScrollResetService,
    NavigationService,
    PdfViewerComponent,
    MsalService,
    MsalGuard,
    validacionRolService
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA // Agrega CUSTOM_ELEMENTS_SCHEMA a la lista de schemas
  ]
})
export class AppModule { }

